import { View } from "binder"
import { BindingEditorViewModel } from "./bindingEditor-viewModel"

export class BindingEditorView extends View<BindingEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-30713068-AF9B-47EC-98BF-656DA838779D"
    }
    loadHtml(): string {
        let element = require('./bindingEditor.html').default;
        let style = require('./bindingEditor.less');
        return element;
    }
    constructor() {
       super();
    }

    public set propertySuggestions(v: string[]) { this._propertySuggestions = v; } public get propertySuggestions(): string[] { return this._propertySuggestions;} private _propertySuggestions: string[];
    public set propertyName(v: string) { this._propertyName = v; } public get propertyName(): string { return this._propertyName;} private _propertyName: string;
    public set converterSuggestions(v: string[]) { this._converterSuggestions = v; } public get converterSuggestions(): string[] { return this._converterSuggestions;} private _converterSuggestions: string[];
    public set converterName(v: string) { this._converterName = v; } public get converterName(): string { return this._converterName;} private _converterName: string;
    public set reverseConverterName(v: string) { this._reverseConverterName = v; } public get reverseConverterName(): string { return this._reverseConverterName;} private _reverseConverterName: string;

    reset(){
        this.dataContext.reset();
    }
}
